export const VENDOR_GUIDE_LINK = 'https://tread.ai/vendorguide/';
